import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";

const NFeCadastroDestinoOperacaoView = () => {
  const navigate = useNavigate();

  const destinoOperacaoSelecionado = () =>
    getLocal<NFeDto>(STORAGENFE_KEY)?.destinoOperacao ?? undefined;

  const selecionado = destinoOperacaoSelecionado() != undefined;

  const handleSalvar = (tipo: number) => () => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      destinoOperacao: tipo,
    });
    navigate("../item");
  };

  const handleVoltar = () => () => {
    navigate("../consumidorfinal");
  };

  const handleProximo = () => {
    navigate("../item");
  };

  const buttonVariant = (operacao: number) => {
    const tipo = destinoOperacaoSelecionado();

    if (tipo === undefined || tipo === operacao) {
      return "primary";
    }

    return "outline-primary";
  };

  return (
    <>
      <Row>
        <Col xs={12} className="d-grid mt-3">
          <Button
            type="submit"
            onClick={handleSalvar(1)}
            variant={buttonVariant(1)}
          >
            1 - Interna
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="d-grid mt-3">
          <Button
            type="submit"
            onClick={handleSalvar(2)}
            variant={buttonVariant(2)}
          >
            2 - Interestadual
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="d-grid mt-3">
          <Button
            type="submit"
            onClick={handleSalvar(3)}
            variant={buttonVariant(3)}
          >
            3 - Exterior
          </Button>
        </Col>
      </Row>
      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={!selecionado ? 12 : 6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar()}>
                Voltar
              </Button>
            </Col>
            {selecionado && (
              <Col xs={6} className="d-grid">
                <Button
                  variant="outline-primary"
                  type="submit"
                  onClick={handleProximo}
                >
                  Próximo
                </Button>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};
export default NFeCadastroDestinoOperacaoView;
